import { useState } from "react";
import Cross from "../../../assets/icons/Cross";
import DefaultButton from "../../default-button/DefaultButton";
import ArrowLeft from "../../../assets/icons/ArrowLeft";
import Tick from "../../../assets/icons/Tick";
import { simpleGetter } from "../../../actions/common";
import { mainApi, userApi } from "../../../api/api";
import { showSnackbar } from "../../../misc/utils";
import { accessGlobalMiscState } from "../../../stores/misc";

type Props = {
  setIsAddModalOpen: (value: boolean) => void;
  addUser: (value: string) => void;
};

export default function AddUserModal({ setIsAddModalOpen }: Props) {
  const [input, changeInput] = useState("");

  const addUser = async () => {
    const response = await simpleGetter(mainApi.getUserByEmail, {
      email: input
    })
    if (response.id) {
      const addResponse = await simpleGetter(userApi.findOrCreateMainUser, response)
      if (addResponse.success) {
        if (addResponse.is_created) {
          accessGlobalMiscState().set('accessesMainUsersTriggerFetch', (accessGlobalMiscState().get('accessesMainUsersTriggerFetch') || 0) + 1)
        }
        showSnackbar(addResponse.is_created ? "Успешно" : "Данный пользователь уже зарегистрирован в системе", addResponse.is_created ? "success" : "error");
        setIsAddModalOpen(false)
      }
    } else {
      showSnackbar("Пользователь не найден")
    }
  }

  const validateForm = () => Boolean(input.length)

  return (
    <div className="w-fit p-8 rounded-xl bg-white text-black absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col">
      <div>
        <div
          onClick={() => setIsAddModalOpen(false)}
          className="flex justify-end cursor-pointer"
        >
          <Cross additionalStyle="text-[#5F6B88]" />
        </div>
        <p className="text-black font-normal text-[24px]">
          Добавление пользователя
        </p>
      </div>
      <div className="flex-grow mt-8">
        <p className="font-medium text-[15px] text-[#5F6B88]">E-mail</p>
        <textarea
          value={input}
          onChange={(e) => changeInput(e.target.value)}
          className="bg-[#F0F3FA] w-full resize-none outline-none rounded-lg px-4 py-3 mt-2 h-1/3"
          placeholder="Введите e-mail пользователя"
        />
      </div>
      <div className="grid grid-cols-[5fr_7fr] gap-3 mt-4">
        <DefaultButton
          buttonText="Вернуться"
          additionalStyle="bg-[#5F6B88] text-white px-8 py-3 text-nowrap"
          Icon={ArrowLeft}
          onClick={() => setIsAddModalOpen(false)}
        />
        <DefaultButton
          disabled={!validateForm()}
          buttonText="Добавить"
          additionalStyle={`bg-[#3BBC30] text-white px-8 py-3 text-nowrap ${!validateForm() ? 'opacity-30' : ''}`}
          Icon={Tick}
          onClick={addUser}
        />
      </div>
    </div>
  );
}
